export default __webpack_public_path__ + "static/media/logo.43968759.png";